import { render, staticRenderFns } from "./DialogLoading.vue?vue&type=template&id=bf85cdf2&scoped=true"
import script from "./DialogLoading.vue?vue&type=script&lang=js"
export * from "./DialogLoading.vue?vue&type=script&lang=js"
import style0 from "./DialogLoading.vue?vue&type=style&index=0&id=bf85cdf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf85cdf2",
  null
  
)

export default component.exports